export const LAYOUT_RESPONSIVE = 'responsive'
export const LAYOUT_CONTAIN = 'contain'
export const LAYOUT_COVER = 'cover'

export const VALID_IMAGE_LAYOUTS = [LAYOUT_RESPONSIVE, LAYOUT_CONTAIN, LAYOUT_COVER] as const

export const IMAGE_LOADING_EAGER = 'eager'
export const IMAGE_LOADING_LAZY = 'lazy'
export const IMAGE_LOADING = [IMAGE_LOADING_EAGER, IMAGE_LOADING_LAZY] as const
